import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import styled from "styled-components/macro";

import {
  LeadText,
  WrapperVerticalPadding,
  sidePadding,
} from "Payments/PaymentPage/PaymentFormScreen/styles";
import { usePaymentPage } from "Payments/PaymentPage/PaymentPageContext";
import { useGetPaymentTypeVerbiage } from "Payments/PaymentPage/Shared/useGetPaymentTypeVerbiage";
import { motion } from "framer-motion";
import qs from "qs";

import { lightenDarkenColor } from "Utilities/Colors/colorUtils";
import useComponentIsMounted from "Utilities/Hooks/useComponentIsMounted";

export default function IntroSection({ introIsComplete }) {
  const {
    state: {
      fund: { description, fundColorSafe },
      noteInfo,
      paymentParent,
    },
  } = usePaymentPage();

  const location = useLocation();
  const {
    pledgeID: pledgeIDParam,
    amount,
    recurringSchedule,
    recurringStartDate,
    recurringEndDate,
    emailPhone,
    signupListID: signupID,
  } = qs.parse(location.search, {
    ignoreQueryPrefix: true,
  });

  const titleColor = lightenDarkenColor(fundColorSafe, -30);

  const [hasAnimated, setHasAnimated] = useState(false);

  const isMounted = useComponentIsMounted();

  const campaign = window?.data?.paymentPageData?.campaign;
  const hasPledgeIDParam = pledgeIDParam;
  const forPledge =
    (hasPledgeIDParam && campaign?.title) ||
    (hasPledgeIDParam &&
      campaign?.title &&
      amount &&
      recurringSchedule &&
      recurringStartDate &&
      recurringEndDate &&
      emailPhone);
  const signupName = window?.data?.paymentPageData?.signupName;

  // always use payment language if this is for a signup
  const { leadText } = useGetPaymentTypeVerbiage(
    signupID && signupName && "signup"
  );

  const fundNameText = forPledge
    ? campaign.title
    : signupID && signupName
    ? signupName
    : description;

  useEffect(() => {
    if (introIsComplete) {
      const animatedTimeout = setTimeout(() => setHasAnimated(true), [250]);
      return () => clearTimeout(animatedTimeout);
    }
  }, [introIsComplete]);

  if (paymentParent?.hideFundHeader) return null;

  return (
    <Wrapper>
      {(!noteInfo || !noteInfo.noteID) && <WrapperVerticalPadding />}
      <Lead
        style={{ justifyContent: introIsComplete ? "flex-start" : "center" }}
      >
        <LeadInside
          key={!hasAnimated && isMounted ? "1" : "2"}
          layout={!hasAnimated && isMounted}
        >
          <LeadText>{forPledge ? `For your pledge to` : leadText}</LeadText>
        </LeadInside>
      </Lead>
      <FundName
        color={paymentParent?.themeColor || titleColor}
        style={{ justifyContent: introIsComplete ? "flex-start" : "center" }}
        data-cy="fund-it-fund-name"
      >
        {fundNameText?.split(" ").map((word, index, allWords) => (
          <Word
            key={(!hasAnimated && isMounted ? "1_" : "2_") + index}
            layout={!hasAnimated && isMounted}
          >
            {word}
            {index < allWords.length - 1 && "\u00A0"}
          </Word>
        ))}
      </FundName>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  ${sidePadding}
  padding-bottom: 20px;
`;

const Lead = styled(motion.div)`
  height: auto;
  display: flex;
  justify-content: center;
`;
const LeadInside = styled(motion.div)`
  padding: 0 14px;
`;

const FundName = styled.div`
  color: ${({ color }) => color};
  font-weight: 600;
  font-size: 28px;
  line-height: 1.2;
  text-align: center;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  padding: 0 14px;
`;

const Word = styled(motion.div)``;
